import { useTranslation } from "react-i18next";
import MScreen from "../../components/pos/MScreen";
import DoneIcon from "@mui/icons-material/Done";
import MText from "../../components/pos/MText";
import { useEffect, useState } from "react";
import { Typography, Grid } from "@mui/material";
import { PricingUtils } from "../../utils/PricingUtils";
import MCheck from "../../components/pos/MCheck";
import MSelect from "../../components/pos/MSelect";
import PSelect from "../../components/pos/PSelect";
import PDatePicker from "../../components/pos/PDatePicker";
export default function MEditService(props, ref) {
  const { t, i18n } = useTranslation();
  const translate = t;

  const [srStatus, setSrStatus] = useState(null);
  const [srAssignee, setSrAssignee] = useState(null);
  const [srEta, setSrEta] = useState(null);

  useEffect(() => {
    setSrStatus(props.srStatus);
    setSrAssignee(props.srAssignee);
    setSrEta(props.srEta);
  }, []);

  function onSave() {
    props.setSrStatus(srStatus);
    props.setSrAssignee(srAssignee);
    props.setSrEta(srEta);
    console.log("LOG");
    props.setCurrentScreen("sale");
  }

  return (
    <MScreen
      title={
        translate("Service") +
        " " +
        (props.srNumber === "NEW" ? "" : props.srNumber)
      }
      isMoreMenuEnabled={true}
      onRedirectToBack={() => props.setCurrentScreen("sale")}
      rightAction={translate("OK")}
      onRightAction={() => {
        onSave();
      }}
      rightActionIcon={<DoneIcon></DoneIcon>}
      enbaleRightAction={true}
      onLogOut={props.onLogOut}
      content={
        <div>
          <PSelect
            style={{ marginTop: "5px" }}
            options={props.statusOptions}
            value={srStatus}
            label={translate("Status")}
            onChange={(event, newValue) => {
              setSrStatus(newValue);
            }}
          ></PSelect>
          <PSelect
            style={{ marginTop: "7px" }}
            options={props.userOptions}
            value={srAssignee}
            label={props.srAssigneeLabel}
            onChange={(event, newValue) => {
              setSrAssignee(newValue);
            }}
          ></PSelect>
          <div style={{ marginTop: "7px" }}>
            <PDatePicker
              label={"Delivery Date"}
              value={srEta}
              onChange={(value) => setSrEta(value)}
            ></PDatePicker>
          </div>
        </div>
      }
    ></MScreen>
  );
}
